module.exports = __webpack_public_path__ + "static/jan_szczepowski-e74d1931987b27766a441b2abf74b23e.mp3";